import { fromJS, Map, List } from 'immutable';
import { OrdersRecord, OrderInfoRecord } from './../Record/Orders';

const NAME_SPACE = 'ORDERS/';
const initialState = Map({
  pageSize: 0,
  currentPage: 0,
  count: 0,
  isInstantlySave: false,
  data: List([new OrdersRecord({ orders_info: List([new OrderInfoRecord()]) })]),
  loading: false,
  delQueue: List([])
});

const item = (state, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return initialState;
    case NAME_SPACE + 'ADD_ORDERS':
      return state.update('data', data => {
        return data.push(fromJS(action.payload.orders));
      });
    case NAME_SPACE + 'EDIT_ORDERS':
      return state.update('data', data => {
        return data.update(data.findIndex(x => x.get('o_id') === action.payload.oId), orders => {
          return orders.merge(action.payload.orders);
        });
      });
    case NAME_SPACE + 'EDIT_ORDERSINFO':
      return state.update('data', data => {
        return data.update(data.findIndex(x => x.get('o_id') === action.payload.oId), orders => {
          return orders.update('orders_info', orders_info => {
            return orders_info.update(orders_info.findIndex(x => x.get('oi_id') === action.payload.oIId), info => {
              return info.merge(action.payload.ordersInfo);
            });
          });
        });
      });
    case NAME_SPACE + 'EDIT_ORDERS_M':
      return state.update('data', data => {
        return data.map(orders => {
          return orders.merge(action.payload.orders);
        })
      });
    // case NAME_SPACE + 'EDIT_ORDERS_M':
    //   return state.update('data', data => {
    //     return data.update(data.findIndex(x => x.get('oi_id') === action.payload.oIId), orders => {
    //       return orders.merge(action.payload.orders);
    //     });
    //   });
    case NAME_SPACE + 'EDIT_ORDERSINFO_M':
      return state.update('data', data => {
        return data.update(data.findIndex(x => x.get('oi_id') === action.payload.oIId), orders => {
          return orders.update('orders_info', orders_info => {
            return orders_info.update(orders_info.findIndex(x => x.get('oi_id') === action.payload.oIId), info => {
              return info.merge(action.payload.ordersInfo);
            });
          });
        });
      });
    case NAME_SPACE + 'DEL_ORDERSINFO_M':
      return state.update('data', data => {
        return data.delete(data.findIndex(x => x.get('oi_id') === action.payload.oIId));
      });
    case NAME_SPACE + 'DEL_QUEUE_PUSH':
      return state.update('delQueue', data => {
        return data.push(action.payload);
      });
    case NAME_SPACE + 'EDIT_GROUPTAGS':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('group_tags', (tags) => {
            return (fromJS(action.payload));
          });
        });
      });
    case NAME_SPACE + 'ADD_TRAVELLER':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('traveller', (traveller) => {
            return traveller.push(fromJS(action.payload.traveller));
          });
        });
      });
    case NAME_SPACE + 'EDIT_TRAVELLER':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('traveller', traveller => {
            return traveller.update(traveller.findIndex(x => x.get('ori_id') === action.payload.oriId), info => {
              return info.merge(action.payload.traveller);
            });
          });
        });
      });
    case NAME_SPACE + 'DEL_TRAVELLER':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('traveller', (traveller) => {
            return traveller.delete(traveller.findIndex(x => x.get('ori_id') === action.payload.oriId));
          });
        });
      });
    case NAME_SPACE + 'ADD_BILLTRANSACTION':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('payment', (payment) => {
            return payment.push(fromJS(action.payload.payment));
          });
        });
      });
    case NAME_SPACE + 'EDIT_BILLTRANSACTION':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('payment', payment => {
            return payment.update(payment.findIndex(x => x.get('obt_id') === action.payload.obtId), row => {
              return row.merge(action.payload.payment);
            });
          });
        });
      });
    case NAME_SPACE + 'DEL_BILLTRANSACTION':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('payment', (payment) => {
            return payment.delete(payment.findIndex(x => x.get('obt_id') === action.payload.obtId));
          });
        });
      });
    case NAME_SPACE + 'ADD_SCHEDULE':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('schedules', (schedules) => {
            return (schedules || new List([])).push(action.payload.schedule);
          });
        });
      });
    case NAME_SPACE + 'DEL_SCHEDULE':
      return state.update('data', data => {
        return data.update(0, orders => {
          return orders.update('schedules', (schedules) => {
            return schedules.update(schedules.findIndex(x => x.get('o_s_id') === action.payload.id), item => {
              return item.merge({ del: 1 });
            });
          });
        });
      });
    case NAME_SPACE + 'RECEIVE_ORDERS':
      return fromJS(action.payload);
    case NAME_SPACE + 'RECEIVE_ORDERS_COLLECTION':
      return fromJS(action.payload);
    case NAME_SPACE + 'V_LOADING':
      return state.update('loading', loading => action.payload.state);
    case NAME_SPACE + 'MODIFY_SAVE_STATUS':
      return state.update('isInstantlySave', state => action.payload.state);
    default:
      return state;
  }
};

const Orders = (state = initialState, action) => {
  switch (action.type) {
    case NAME_SPACE + 'RECEIVE_INITIALSTATE':
      return item(undefined, action);
    case NAME_SPACE + 'ADD_ORDERS':
      return item(state, action);
    case NAME_SPACE + 'EDIT_ORDERS':
      return item(state, action);
    case NAME_SPACE + 'EDIT_ORDERSINFO':
      return item(state, action);
    case NAME_SPACE + 'EDIT_ORDERS_M':
      return item(state, action);
    case NAME_SPACE + 'EDIT_ORDERSINFO_M':
      return item(state, action);
    case NAME_SPACE + 'DEL_ORDERSINFO_M':
      return item(state, action);
    case NAME_SPACE + 'DEL_QUEUE_PUSH':
      return item(state, action);
    case NAME_SPACE + 'ADD_SCHEDULE':
      return item(state, action);
    case NAME_SPACE + 'DEL_SCHEDULE':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_ORDERS':
      return item(state, action);
    case NAME_SPACE + 'RECEIVE_ORDERS_COLLECTION':
      return item(state, action);
    case NAME_SPACE + 'V_LOADING':
      return item(state, action);
    case NAME_SPACE + 'MODIFY_SAVE_STATUS':
      return item(state, action);
    case NAME_SPACE + 'EDIT_TRAVELLER':
      return item(state, action);
    case NAME_SPACE + 'DEL_TRAVELLER':
      return item(state, action);
    case NAME_SPACE + 'ADD_TRAVELLER':
      return item(state, action);
    case NAME_SPACE + 'EDIT_BILLTRANSACTION':
      return item(state, action);
    case NAME_SPACE + 'DEL_BILLTRANSACTION':
      return item(state, action);
    case NAME_SPACE + 'ADD_BILLTRANSACTION':
      return item(state, action);
    case NAME_SPACE + 'EDIT_GROUPTAGS':
      return item(state, action);
    default:
      return state;
  }
};

export default Orders;
